import React, { Component } from "react";
import { Form } from "react-bootstrap";

export default class ContactTextInput extends Component {
	render() {
		const {
			controlId,
			value,
			onChange,
			labelName,
			name,
			placeholder,
			type,
		} = this.props;
		return (
			<Form.Group className="text-left" controlId={controlId}>
				<Form.Label>{labelName}</Form.Label>
				<Form.Control
					name={name}
					type={type}
					placeholder={placeholder}
					value={value}
					onChange={onChange}
				/>
			</Form.Group>
		);
	}
}
